import { Component } from '@angular/core';

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    standalone: false
})
export class ImprintComponent {}
